import * as React from 'react';

import {FormField} from 'shells/form/form-field';
import {Stack} from 'shells/layout/stack/stack';
import {TextField} from 'shells/textfield/textfield';
import {ModalSubheader} from 'shells/typography/modal-subheader';

type Props = {
    apiKey: string;
    accountId: string;
    companyId: string;
    callrailEmail: string;
    setApiKey: (apiKey: string) => void;
    setAccountId: (accountId: string) => void;
    setCompanyId: (companyId: string) => void;
    setCallrailEmail: (callrailEmail: string) => void;
};

export function CallrailForm(props: Props) {
    return (
        <>
            <ModalSubheader>
                We’ll need a few details from within your CallRail account to set up your
                integration.
            </ModalSubheader>
            <Stack spacing={16}>
                <FormField
                    innerId='apiKey'
                    label='API Key'
                    noMargin={true}
                    tooltipInfo='An API key can be generated in the Integrations tab under Data access.'
                >
                    <TextField value={props.apiKey} onChange={(value) => props.setApiKey(value)} />
                </FormField>
                <FormField
                    innerId='accountId'
                    label='Account ID'
                    noMargin={true}
                    tooltipInfo='Your Account ID is the 9-digit number found by clicking "My Account" in the top left, or in the page URL when logged in.'
                >
                    <TextField
                        value={props.accountId}
                        onChange={(value) => props.setAccountId(value)}
                    />
                </FormField>
                <FormField
                    innerId='companyId'
                    label='Company ID'
                    noMargin={true}
                    tooltipInfo='The Company ID is under each company on the "All companies" tab in Account settings, or the second number in the URL when on a page with company-specific info.'
                >
                    <TextField
                        value={props.companyId}
                        onChange={(value) => props.setCompanyId(value)}
                    />
                </FormField>
                <FormField
                    innerId='callrailEmail'
                    label='CallRail Email'
                    noMargin={true}
                    tooltipInfo='The email address you use to log in to CallRail.'
                >
                    <TextField
                        value={props.callrailEmail}
                        onChange={(value) => props.setCallrailEmail(value)}
                    />
                </FormField>
            </Stack>
        </>
    );
}
